export default {
  title: 'O Criador de Sites está passando por melhorias',
  description: 'Estamos trabalhando em atualizações no Criador de Sites para ' +
               'melhorar a sua experiência, e algumas funções estarão temporariamente ' +
               'indisponíveis no momento, mas você ainda pode editar o seu site normalmente ' +
               'clicando no menu <b>Site</b>, e em seguida em <b>Editar site</b>. Se precisar de ajuda ' +
               'acesse a nossa Wiki com artigos sobre como utilizar o Editor de Sites.',
  wikiButton: 'Acessar Wiki'
}
